;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import clsx from 'clsx'
import React, { forwardRef } from 'react'

type SelectProps = React.SelectHTMLAttributes<HTMLSelectElement> & {
  className?: string
  invalid?: boolean
}

export const Select = forwardRef(function Select(
  { className, multiple, invalid, disabled, ...props }: SelectProps,
  ref: React.ForwardedRef<HTMLSelectElement>,
) {
  return (
    <span data-slot="control" className={clsx(className, 'group relative block w-full')}>
      <select
        ref={ref}
        multiple={multiple}
        disabled={disabled}
        data-invalid={invalid || undefined}
        data-disabled={disabled || undefined}
        {...props}
        className={clsx([
          'relative block w-full appearance-none rounded-2xl py-3 text-sm/7',
          multiple ? 'px-4' : 'pr-10 pl-4',
          '[&_optgroup]:font-semibold',
          'text-mist-950 placeholder:text-mist-500 dark:text-white dark:*:text-white dark:placeholder:text-mist-400',
          'border border-mist-950/10 bg-white shadow-sm dark:border-white/10 dark:bg-mist-950/70 dark:*:bg-mist-900',
          'focus:border-mist-950/40 focus:ring-4 focus:ring-mist-950/5 focus:outline-hidden dark:focus:border-white/30 dark:focus:ring-white/10',
          'data-[invalid=true]:border-red-500 data-[invalid=true]:hover:border-red-500 data-[invalid=true]:focus:border-red-500 data-[invalid=true]:focus:ring-red-500/20 dark:data-[invalid=true]:border-red-600 dark:data-[invalid=true]:hover:border-red-600 dark:data-[invalid=true]:focus:border-red-600 dark:data-[invalid=true]:focus:ring-red-500/25',
          'data-[disabled=true]:bg-mist-950/5 data-[disabled=true]:opacity-50 dark:data-[disabled=true]:bg-white/5',
        ])}
      />
      {!multiple && (
        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
          <svg
            className="size-5 stroke-mist-500 group-has-data-[disabled=true]:stroke-mist-600 sm:size-4 dark:stroke-mist-400 forced-colors:stroke-[CanvasText]"
            viewBox="0 0 16 16"
            aria-hidden="true"
            fill="none"
          >
            <path d="M5.75 10.75L8 13L10.25 10.75" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.25 5.25L8 3L5.75 5.25" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      )}
    </span>
  )
})
